import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
const MoreDetailsButton = ({ href, userAnalyser, renter, priceDaily, priceTotal, currencySymbol, currency, DropOffDate, pickUpDate, pickUpTime, totalDays, priceNotDiscounted, rate, taxes, t, filters, pageNumber, itemIndex }) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 999);
    const [isActive, setIsActive] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 999);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const handleTouchClick = (event) => {
        setIsActive(!isActive);
    };
    const handleOnClick = (e) => {
        sessionStorage.setItem("filters", JSON.stringify(filters));
        sessionStorage.setItem("shouldFilter", "true");
        sessionStorage.setItem("itemIndex", itemIndex.toString());
        e.preventDefault();
        if ((renter === null || renter === void 0 ? void 0 : renter.rateQualifier[0].rateType) == 2)
            href =
                href +
                    ((href === null || href === void 0 ? void 0 : href.includes("?"))
                        ? "&paymentOnDestination=true"
                        : "?paymentOnDestination=true");
        window.location.href = href + "&pay=nnn";
        setTimeout(() => {
            const elements = document.querySelectorAll(".button-primary");
            elements.forEach((element) => {
                element.classList.remove("touched_button_availability");
            });
        }, 100);
    };
    const className = `button button-primary button--bg-gradient-primary264g button--rounded ${isActive ? "touched_button_availability" : ""}`;
    return (_jsx("a", { href: href, className: className, onTouchStart: handleTouchClick, onTouchEnd: handleTouchClick, onClick: handleOnClick, id: "availability-to-details", children: t("btn-booking") }));
};
export default MoreDetailsButton;
